export const DEFAULT = 'DEFAULT_DAILY_INTAKE';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_DAILY_INTAKE';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_DAILY_INTAKE';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_DAILY_INTAKE';
export const SET_RER = 'SET_RER_DAILY_INTAKE';
export const SET_DER = 'SET_DER_DAILY_INTAKE';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
